module.exports = __webpack_public_path__ + "media/Images/SwirlYellow-7f0e2db7.svg";